<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" style="display:none;"  />
        
        <div style="margin-bottom:100px;">
            <tabsComp :tabs="tabs" />
            <div class="text-end" style="margin-inline-end: 30px;">
                <b-button
                v-if="lang.langname == 'ar'"
                    v-b-toggle.add_new_card
                    class="btn-sm btn addMobile"
                    @click="resetAllValues()"
                    style="margin-top:9px;background:transparent;border:none !important;margin-left:-7px !important;"
                    id="multiply-button" 
                  >
                    <div :class="`multiply-button-content-`+lang.lalgin" style="width:150px;border:none !important">{{lang.add_maint_request}}</div>
                </b-button>
                <b-button
                    v-if="lang.langname == 'en'"
                    v-b-toggle.add_new_card
                    class="btn-sm btn addMobile"
                    @click="resetAllValues()"
                    style="margin-top:9px;background:transparent;border:none !important;margin-left:-7px !important;"
                    id="multiply-button" 
                  >
                    <div :class="`multiply-button-content-`+lang.lalgin" style="width:150px;border:none !important">{{lang.add_maint_request}}</div>
                </b-button>
            </div>
            <v-row>
                <v-col cols="12">
                    <div class="dashPathes">
                        <div class="pathNumber" v-for="(item,index) in carPathes" :key="index" style="cursor:pointer">
                            <div class="pathBody">
                                <div class="pathNumberValue" :style="item.status_style">{{ item.path_number }}</div>
                                <div class="itemsRows">
                                    <div style="background:#ccc;width:166px;padding:3px 10px;font-size:0.7rem">{{item.customer_name}}</div>
                                    <div :style="`background:#ccc;width:166px;padding:3px 10px;font-size:0.7rem;margin-top:2px;`">{{ item.mobile }}</div>
                                    <div :style="`background:#ccc;width:166px;padding:3px 10px;font-size:0.7rem;margin-top:2px;${item.status_style}`">{{ item.status_name[`${lang.langname}`] }}</div>
                                    <div style="border:1px solid #eee;border-radius:5px;background:#add8e654;width:190px;padding:3px 8px;font-size:0.7rem;margin-top:4px;">{{lang.vin_number}}: {{item.vin}}</div>
                                    <div style="border:1px solid #eee;border-radius:5px;background:#add8e654;width:190px;padding:3px 8px;font-size:0.7rem;margin-top:4px;">{{lang.plate_number}}: {{item.plate_number}}</div>
                                    <div style="border:1px solid #eee;border-radius:5px;background:#add8e654;width:190px;padding:3px 8px;font-size:0.7rem;margin-top:4px;">{{lang.car_model}}: {{item.model}}</div>
                                    <div style="border:1px solid #eee;border-radius:5px;background:#add8e654;width:190px;padding:3px 8px;font-size:0.7rem;margin-top:4px;">{{lang.car_year}}: {{item.made_year}}</div>
                                    <div style="border:1px solid #eee;border-radius:5px;background:#add8e654;width:190px;padding:3px 8px;font-size:0.7rem;margin-top:4px;">{{lang.balance}}: {{item.cart_total}}</div>
                                    <div style="border:1px solid #eee;border-radius:5px;background:#add8e654;width:190px;padding:3px 8px;font-size:0.7rem;margin-top:4px;">{{lang.total_balance}}: {{item.all_total}}</div>
                                </div>
                            </div>
                            <div  @click="openCard(item.path_number)" v-b class="pathFoot">{{ lang.action }}</div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <Footer />
        <viewPathes ref="viewPathes" />
        <addNewCard ref="createnew" />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import tabsComp from '@/components/tabsComp.vue'
import ExportsPrint from '@/components/exports-print.vue';
import viewPathes from '@/components/viewPathes.vue';
import addNewCard from "@/components/addNewCard.vue"
import axios from 'axios'
import { getVisibleTabsForRoute } from '@/menu/menuService'
export default{
    components: {HeaderPortrate,Footer,tabsComp,ExportsPrint,viewPathes,addNewCard},
    data(){
        return {
            carPathes: [],
            showtable: false,
            showFix: false,
            sd: {
                day: 1,
                month: 1,
                year: (new Date()).getFullYear()
            },
            ed: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear()
            },
            
            search: '',
        }
    },
    computed:{
        lang: function(){
          if(this.$cookies.get(this.$store.state.LangCooki) != null){
              if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
              return this.$store.state.lang.en;
              }else{
              return this.$store.state.lang.ar;
              }
          }
          else if(this.$store.state.deflang == 'en'){
              return this.$store.state.lang.en;
          }else{
              return this.$store.state.lang.ar;
          }
      },


      items:function() {
          return {
            text: this.lang.invoices,
            disabled: true,
            href: '/invoicelist/',
          }
      },
      tabs: function() {

          return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);

      },
    },
    methods:{
        openCard(id){
            //window.open('./api/print.php?path_number='+id,"_blank")
            this.$refs.viewPathes.id = id;
            this.$refs.viewPathes.path_info = {};
            this.$refs.viewPathes.getStaticOptions();
            this.$refs.viewPathes.getPathInfo();
        },
        resetAllValues(){
            this.$refs.createnew.resetValues();
            this.$refs.createnew.getInvSettings();
            this.$refs.createnew.$refs.firstCar.images = '';
        },
        getDashboard(){
            let cook = this.$cookies.get(this.$store.state.COOKIEPhase);
            let post = new FormData();
            post.append('type','getCarPathes');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('lang',this.$cookies.get(this.$store.state.LangCooki))
            post.append('auth',cook);
            post.append('data[start]',this.sdate);
            post.append('data[end]',this.edate)
            axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            ).then((response) => {
                if(response && response.data && response.data.results){
                    this.carPathes = response.data.results.data;
                }
            })
            // console.log(response.data)
            
        },
        getCurrentCards() {
            this.getDashboard();
        }
    },
    created(){
        this.getDashboard();
    }
}

</script>

<style scoped>
.dashPathes{
    display:flex;
    flex-direction:row;
    flex-wrap:wrap;
    justify-content:center;
    justify-items:center;
    align-self:center;
}
.itemsRows{
    font-size:0.7rem;
}
.pathBody{
    display:flex;
    position: relative;
    width:100%;
    height: calc(260px - 30px);
    padding:5px;
}
.pathNumberValue{
    position: absolute;
    top: 5px;
    left: 5px;
    width:50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    align-items: center;
    background:yellow;
    border:1px solid #000;
    border-radius: 25px;
    font-size:1.4rem;
}
.pathNumber{
    background: #fff;
    border:1px solid #000;
    box-shadow: inset #000;
    color:#000;
    display: flex;
    flex-direction:column;
    flex-wrap:wrap;
    justify-content:space-between;
    justify-items:center;
    align-items:center;
    font-size:5rem;
    width:200px;
    height: 280px;
    margin:5px;
    border-radius: 5px;
}
.pathTitle{
    background-color:#000;
    color:#fff;
    width:100%;
    text-align:center;
    padding:3px;
}
.pathFoot{
    background-color:blue;
    color:#fff;
    width:100%;
    text-align:center;
    padding:3px;
    cursor: pointer;
}
.cusModal{
    position: fixed;
    background:#0000001a;
    top:0;
    left:0;
    bottom:0;
    right:0;
    z-index: 20000000;
    display:flex;
    justify-content: center;
    justify-items: center;
    align-items: center;;
}
.cusModalCont{
    position:relative;
    width:70%;
    height: 70vh;
    border:1px solid #bbb;
    background:#fff;
    box-shadow: 0px 1px 1px 1px #0000001a;
    border-radius: 5px;
}
.cusModalClose{
    position: absolute;
    top:2px;
    left:10px;
    background:red;
    color:#fff;
    border:1px solid #555;
    border:#ccc;
    border-radius: 2px;
    padding:4px 10px;
    cursor: pointer;
    box-shadow: 0px 1px 1px 1px #0000001a;
}
.cusModalCloseL:hover{
    background: darkred;
}
.cusModalTitle{
    padding:5px;
    text-align:center;
    border-color: #bbb !important;
    border-bottom-color: #000 !important;
}
.cusModalBody{
    overflow: auto;
    height:calc(70vh - 50px);
    max-height:calc(70vh - 50px);
    padding:5px;
}
.dashBoard{
    margin-inline:10px;
    display:flex;
    flex-direction:row;
    flex-wrap:wrap;
    justify-content:space-around;
    justify-items:center;
    align-self:center;
}
.cusModal{
    position: fixed;
    background:#0000001a;
    top:0;
    left:0;
    bottom:0;
    right:0;
    z-index: 20000000;
    display:flex;
    justify-content: center;
    justify-items: center;
    align-items: center;;
}
.cusModalCont{
    position:relative;
    width:70%;
    height: 70vh;
    border:1px solid #bbb;
    background:#fff;
    box-shadow: 0px 1px 1px 1px #0000001a;
    border-radius: 5px;
}
.cusModalClose{
    position: absolute;
    top:2px;
    left:10px;
    background:red;
    color:#fff;
    border:1px solid #555;
    border:#ccc;
    border-radius: 2px;
    padding:4px 10px;
    box-shadow: 0px 1px 1px 1px #0000001a;
}
.cusModalCloseL:hover{
    background: darkred;
}
.cusModalTitle{
    padding:5px;
    text-align:center;
    border-color: #bbb !important;
    border-bottom-color: #000 !important;
}
.cusModalBody{
    overflow: auto;
    height:calc(70vh - 50px);
    max-height:calc(70vh - 50px);
    padding:5px;
}
</style>